<template>
  <form @submit.prevent="$emit('submit')" class="white-box p30">
    <div class="row">
      <div class="col-sm-6">
        <FieldSelect name="Mailer" rules="required" v-model="value.mailer"
          :options="[{ text: 'Mailgun', value: 'mailgun' }, { text: 'SMTP', value: 'smtp' }]" />
      </div>
      <div class="col-sm-6">
        <FieldTextInput name="Host" rules="required" v-model="value.host" />
      </div>
      <div class="col-sm-6">
        <FieldTextInput name="Port" rules="required" v-model="value.port" />
      </div>
      <div class="col-sm-6">
        <FieldTextInput name="Username" rules="required" v-model="value.username" />
      </div>
      <div class="col-sm-6">
        <FieldTextInput name="Password" rules="required" v-model="value.password" />
      </div>
      <div class="col-sm-6">
        <FieldTextInput name="Encryption" rules="required" v-model="value.encryption" />
      </div>
      <div class="col-sm-6">
        <FieldTextInput name="From Email" rules="required" v-model="value.from_email" />
      </div>
      <div class="col-sm-6">
        <FieldTextInput name="From Name" rules="required" v-model="value.from_name" />
      </div>
    </div>
    <div class="d-flex justify-content-center">
      <button class="btn btn-orange" type="submit">Update</button>
    </div>
  </form>
</template>
<script>
import FieldSelect from '@/components/field/Select.vue';
import FieldTextInput from '@/components/field/TextInput.vue';

export default {
  components: {
    FieldTextInput,
    FieldSelect
  },
  props: ['value', 'disabled'],
}
</script>
